var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hm-balance-card"},[_c('div',{staticClass:"box",class:_vm.options,attrs:{"name":"cardColorTwo"},on:{"tap":_vm.onCard}},[_c('div',{staticClass:"trimStrip",attrs:{"id":"trimStrip"}}),_c('div',{},[_vm._t("header")],2),_c('div',{},[_vm._t("middle")],2),_c('div',{},[_vm._t("footer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }